import { render, staticRenderFns } from "./user-request.vue?vue&type=template&id=5ccea3b9&"
import script from "./user-request.vue?vue&type=script&lang=js&"
export * from "./user-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports